import { render, staticRenderFns } from "./MaintenanceModel.vue?vue&type=template&id=708cd4a9&scoped=true&"
import script from "./MaintenanceModel.vue?vue&type=script&lang=js&"
export * from "./MaintenanceModel.vue?vue&type=script&lang=js&"
import style0 from "./MaintenanceModel.vue?vue&type=style&index=0&id=708cd4a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708cd4a9",
  null
  
)

export default component.exports